import { render, staticRenderFns } from "./CampaignPreviews.vue?vue&type=template&id=492e35cc&scoped=true"
import script from "./CampaignPreviews.vue?vue&type=script&lang=js"
export * from "./CampaignPreviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e35cc",
  null
  
)

export default component.exports